import React from 'react'
import { withTranslation } from 'react-i18next'
import ReportsPeriodFilter from './ReportsPeriodFilter'
import ReportsFilterPill from './ReportsFilterPill'

export default withTranslation()(function ReportsActionBar({
  t, period, onSelectPeriodPreset, onApplyCustomPeriod, onClearPeriod, campaign, onChangeCampaign, campaignOptions
}) {
  const allCampaigns = { label: t('reports.filters.all_campaigns'), value: '' }
  const options = [allCampaigns, ...campaignOptions]

  return (
    <div className="flex items-center justify-between gap-4 mb-5">
      <h1 className="text-2xl font-semibold text-dark-blue">{t('reports.title')}</h1>

      <div className="flex items-center gap-3">
        <ReportsPeriodFilter
          preset={period.preset}
          from={period.from}
          to={period.to}
          onSelectPreset={onSelectPeriodPreset}
          onApplyCustom={onApplyCustomPeriod}
          onClear={onClearPeriod}
        />

        <ReportsFilterPill
          label={t('reports.filters.all_campaigns')}
          active={campaign ? options.find((option) => option.value === campaign) : null}
          options={options}
          onSelect={(option) => onChangeCampaign(option.value)}
          onClear={() => onChangeCampaign('')}
        />
      </div>
    </div>
  )
})
